"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeJwt = void 0;
var oidc_client_ts_and_jwt_decode_1 = require("../vendor/frontend/oidc-client-ts-and-jwt-decode");
exports.decodeJwt = oidc_client_ts_and_jwt_decode_1.jwt_decode_ns.jwtDecode;
//# sourceMappingURL=decodeJwt.js.map